import { render, staticRenderFns } from "./keyword-item.vue?vue&type=template&id=4839febc&"
import script from "./keyword-item.vue?vue&type=script&lang=js&"
export * from "./keyword-item.vue?vue&type=script&lang=js&"
import style0 from "./keyword-item.vue?vue&type=style&index=0&id=4839febc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports